import type { WorldState } from "./types";
import { C, dist, setMessage } from "./shared";
import { trySummon } from "./summon";

export function tickEvents(world: WorldState, dt: number): void {
  if (!world.alliance && world.time >= world.nextPactAt) {
    const alive = world.teams.filter((t) => t.alive);
    if (alive.length >= 2) {
      const a = alive[Math.floor(Math.random() * alive.length)];
      const am = world.entities.find((e) => e.id === a.masterId);
      if (am) {
        const inRange = alive.filter((t) => {
          const m = world.entities.find((e) => e.id === t.masterId);
          return m && dist(m.x, m.y, am.x, am.y) <= C.events.portalPactRadius;
        });
        if (inRange.length >= 2) {
          world.alliance = {
            teamIds: inRange.map((t) => t.id),
            endsAt: world.time + C.events.portalPactDurationSec,
            graceUntil:
              world.time +
              C.events.portalPactDurationSec +
              C.events.allianceEndGraceSec,
            centerX: am.x,
            centerY: am.y,
            radius: C.events.portalPactRadius,
          };
          setMessage(world, "hud.msgPact");
        }
      }
    }
    world.nextPactAt = world.time + C.events.portalPactIntervalSec;
  }

  if (world.alliance && world.time > world.alliance.graceUntil) {
    for (const id of world.alliance.teamIds) {
      const tTeam = world.teams[id];
      if (tTeam) tTeam.allianceGraceUntil = world.time;
    }
    world.alliance = null;
  } else if (
    world.alliance &&
    world.time > world.alliance.endsAt &&
    world.time <= world.alliance.endsAt + 0.05
  ) {
    setMessage(world, "hud.msgPactEnding");
  }

  if (!world.warpCore && world.time >= world.nextWarpAt) {
    world.warpCore = {
      x: world.mapW * (0.3 + Math.random() * 0.4),
      y: world.mapH * (0.3 + Math.random() * 0.4),
      radius: C.events.warpCoreRadius,
      endsAt: world.time + C.events.warpCoreDurationSec,
      contrib: {},
    };
    setMessage(world, "hud.msgWarp");
    world.nextWarpAt = world.time + C.events.warpCoreIntervalSec;
  }

  if (world.warpCore) {
    const core = world.warpCore;
    for (const team of world.teams) {
      if (!team.alive) continue;
      const m = world.entities.find((e) => e.id === team.masterId);
      if (!m) continue;
      if (dist(m.x, m.y, core.x, core.y) <= core.radius) {
        core.contrib[team.id] = (core.contrib[team.id] ?? 0) + dt;
      }
    }
    if (world.time >= core.endsAt) {
      let bestId = -1;
      let best = -1;
      for (const [id, v] of Object.entries(core.contrib)) {
        if (v > best) {
          best = v;
          bestId = Number(id);
        }
      }
      if (bestId >= 0) {
        const winner = world.teams[bestId];
        if (winner?.alive) {
          winner.sigils += C.units.weapon.sigilCost;
          trySummon(world, bestId, "weapon");
          setMessage(world, "hud.msgWarpWin", {}, winner.id);
        }
      }
      world.warpCore = null;
    }
  }
}
